import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class ProcessEquipment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: '',
      height: '',
      amount: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAmount = this.handleChange.bind(null, 'amount');
    this.handleChangeHeight = this.handleChange.bind(null, 'height');
    this.handleChangeLength = this.handleChange.bind(null, 'length');
  }
  handleChange(key, value) {
    const {
      onCalc
    } = this.props;
    this.setState({
      [key]: value
    }, () => {
      const {
        length,
        height,
        amount
      } = this.state;
      if (length !== '' && height !== '' && amount !== '') {
        // Calculate the surface area
        const total = 5 * length * height * amount;

        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const {
      length,
      height,
      amount
    } = this.state;
    const {
      result
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "5 x Length x Height x Amount = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Length",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeLength,
      value: length
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Height",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeHeight,
      value: height
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Amount",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAmount,
      value: amount
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
ProcessEquipment.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};
ProcessEquipment.defaultProps = {
  onCalc: null,
  result: null
};